import React, { PureComponent } from 'react';
import Country from '~/Api/Country/Country';
import { selectCardinalPlural } from '~/utils/Intl';
import {
	Sentence as ApiSentence,
	VirtualPackReimbursement,
} from '~/MedicinalBrandsAnalytics/VirtualBrand/Reimbursement';
import CountryIcon from '~/UI/CountryIcon/CountryIcon';
import Tooltip from '~/UI/Tooltip';
import DarkTooltipStyles from '~/UI/Tooltip/dark.less';

import Sentence from './Sentence';
import styles from './styles.less';

export interface ReimbursementGroup {
	brandName: string;
	virtualPacks: VirtualPackReimbursement[];
	sentences: ApiSentence[];
}

interface Props {
	country: Country;
	reimbursements: ReimbursementGroup[];
}

export default class ReimbursementInfo extends PureComponent<Props> {
	render() {
		const { country, reimbursements } = this.props;

		return (
			<div className={styles.item}>
				<h2 className={styles.header}>
					<CountryIcon code={country.alpha2} name={country.name} />
					<div className={styles.headerText}>{country.name}</div>
				</h2>

				{reimbursements.map(({ brandName, virtualPacks, sentences }) =>
					sentences.map((sentence, i) => {
						return (
							<p className={i > 0 ? styles.otherSentence : styles.sentence} key={JSON.stringify(sentence)}>
								<Sentence
									packageNameRenderer={(packageName) =>
										virtualPacks.length > 1 ? this.renderPack(brandName, virtualPacks) : <strong>{packageName}</strong>
									}
									sentence={sentence}
								/>
							</p>
						);
					})
				)}
			</div>
		);
	}

	renderPack(brandName: string, virtualPacks: VirtualPackReimbursement[]) {
		const reference = (
			<strong>
				{brandName}{' '}
				<u>
					({virtualPacks.length} {selectCardinalPlural(virtualPacks.length, ['package', 'packages'])})
				</u>
			</strong>
		);

		return (
			<Tooltip reference={reference} styles={DarkTooltipStyles}>
				{virtualPacks.map((virtualPack) => (
					<p className={styles.tooltipContent} key={virtualPack.id}>
						{virtualPack.distinctName}
					</p>
				))}
			</Tooltip>
		);
	}
}
